import { useEffect, useState } from "react";

const MOBILE_APP_URL = import.meta.env.VITE_MOBILE_APP_URL || "/mobile";

const WarningScreen = () => {
  const [, setCountdown] = useState(2);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((c) => {
        if (c <= 1) {
          window.location.href = MOBILE_APP_URL;
          return 0;
        }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex justify-center items-center h-screen flex-col bg-wht gap-4">
      <p className="text-lg font-semibold text-black">
        Redirecting to mobile app...
      </p>
      <a
        href={MOBILE_APP_URL}
        className="text-sm text-blue-600 underline"
      >
        Open mobile app now
      </a>
    </div>
  );
};

export default WarningScreen;
